/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MinimalGroupFromJSON, MinimalGroupToJSON, } from './MinimalGroup';
/**
 * Check if a given object implements the RoleDetail interface.
 */
export function instanceOfRoleDetail(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('permissions' in value) || value['permissions'] === undefined)
        return false;
    if (!('groups' in value) || value['groups'] === undefined)
        return false;
    if (!('memberCount' in value) || value['memberCount'] === undefined)
        return false;
    return true;
}
export function RoleDetailFromJSON(json) {
    return RoleDetailFromJSONTyped(json, false);
}
export function RoleDetailFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'description': json['description'] == null ? undefined : json['description'],
        'permissions': json['permissions'],
        'groups': (json['groups'].map(MinimalGroupFromJSON)),
        'memberCount': json['member_count'],
    };
}
export function RoleDetailToJSON(json) {
    return RoleDetailToJSONTyped(json, false);
}
export function RoleDetailToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'description': value['description'],
        'permissions': value['permissions'],
        'groups': (value['groups'].map(MinimalGroupToJSON)),
        'member_count': value['memberCount'],
    };
}
